import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';
import { Column } from 'devextreme/ui/data_grid';

// constants imports
import { StringFormatConstants } from '../../../_constants/string-format-constants';

// component imports
import { WorkOrderBaseComponent } from '../../_base/work-order-base-component';

// model imports
import { BaseWorkOrderParameterDto } from '../../_models/base-work-order-parameter-dto';
import { WorkOrderHistoryResultDto } from '../../_models/work-order-history-result-dto';

@Component({
    selector: 'app-work-orders-history',
    templateUrl: './work-orders-history.component.html',
    styleUrls: ['./work-orders-history.component.scss']
})
export class WorkOrdersHistoryComponent extends WorkOrderBaseComponent implements OnInit {
    @ViewChild('workorderHistoryPopup', { static: false }) workorderHistoryPopup: DxPopupComponent;

    @Input() communityId: number;
    @Input() workOrderId: number;

    @Output() onClose = new EventEmitter<void>();

    visible = false;
    historyTitle: string;

    historyColumns: Array<Column> = [];
    historySource: Array<WorkOrderHistoryResultDto>;

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.show();
        this.setWorkflowHistoryColumns();
        this.historyTitle = `Log of ${this.workOrderId}`;
    }

    show(): void {
        this.visible = true;
        this.getWorkOrderHistory();
    }

    onHistoryShown(): void {
        this.workorderHistoryPopup.instance.repaint();
    }

    onHistoryClose(): void {
        this.closeHistory();
    }

    private getWorkOrderHistory(): void {
        const baseParams: BaseWorkOrderParameterDto = new BaseWorkOrderParameterDto();
        baseParams.workOrderId = this.workOrderId;
        baseParams.communityId = this.communityId;

        this.workOrderHelperService.showLoading();
        this.workOrderService.getWorkOrderHistory(baseParams).subscribe(
            (result: WorkOrderHistoryResultDto[]) => {
                this.historySource = result;
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }

    private setWorkflowHistoryColumns(): void {
        this.historyColumns = [
            {
                dataField: 'beginValue',
                dataType: 'string',
                caption: 'Begin Value'
            },
            {
                dataField: 'endValue',
                dataType: 'string',
                caption: 'End Value'
            },
            {
                dataField: 'modified',
                dataType: 'string',
                caption: 'Modified'
            },
            {
                dataField: 'user',
                caption: 'User',
                cellTemplate: 'userTemplate'
            },
            {
                dataField: 'date',
                dataType: 'datetime',
                caption: 'Date',
                sortIndex: 0,
                sortOrder: 'desc',
                cellTemplate: 'dateTemplate'
            },
            {
                dataField: 'id',
                dataType: 'string',
                caption: 'ID',
                showInColumnChooser: true,
                visible: false
            },
            {
                dataField: 'additionalInfo',
                dataType: 'string',
                caption: 'Additional Information',
                showInColumnChooser: true,
                visible: false
            }
        ];
    }

    private closeHistory(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
